export default {
  新增模板: "新增模板",
  供应商类别: "供应商类别",
  考核维度: "考核维度",
  考核项: "考核项",
  请完善模板信息: "请完善模板信息",
  保存成功: "保存成功",
  更新成功: "更新成功",
  需要至少新增一个考核维度: "需要至少新增一个考核维度",
  "所有考核项的权重总和不能超过100%，当前为{{totalWeight}}%":
    "所有考核项的权重总和不能超过100%，当前为{{totalWeight}}%",
  新增维度: "新增维度",
  "优秀 (100分)": "优秀 (100分)",
  "良好 (75分)": "良好 (75分)",
  "一般 (50分)": "一般 (50分)",
  "差 (25分)": "差 (25分)",
  序号: "序号",
  考核权重: "考核权重",
  考核部门: "考核部门",
  考核等级: "考核等级",
  等级描述: "等级描述",
  操作: "操作",
  必填: "必填",
  输入考核项: "输入考核项",
  选择部门: "选择部门",
  请输入等级描述: "请输入等级描述",
  删除考核项: "删除考核项",
  "您确定要删除该考核项吗？": "您确定要删除该考核项吗？",
  添加: "添加",
  "暂无考核项，请点击下方按钮添加": "暂无考核项，请点击下方按钮添加",
  删除成功: "删除成功",
  确认操作: "确认操作",
  "确认删除该类别吗？": "确认删除该类别吗？",
  请输入维度名称: "请输入维度名称",
  删除考核维度: "删除考核维度",
  "您确定要删除该考核维度吗？": "您确定要删除该考核维度吗？",
  删除阶段: "删除阶段",
  考核标准: "考核标准",
  等级: "等级",
  描述: "描述",
  考核标准权重: "考核标准权重",
  取消: "取消",
};
